/**
 * QueryManager
 *
 * Stops server-owned WildLark task turns. Renderer-owned harness/custom run
 * handles were removed with the runtime protocol migration.
 */

import { makeAutoObservable } from "mobx"
import { requestNestMethod } from "../../nest/client"
import type { CodeStore } from "../store"

export class QueryManager {
    constructor(private store: CodeStore) {
        makeAutoObservable(this)
    }

    async interruptTask(taskId: string): Promise<boolean> {
        if (!this.store.isTaskRunning(taskId)) {
            console.debug("[QueryManager] interruptTask: No Nest task turn is running", taskId)
            return false
        }

        const turnId = this.runningTurnId(taskId)
        if (!turnId) {
            console.debug("[QueryManager] interruptTask: No Nest turn id found", taskId)
            return false
        }

        const result = await requestNestMethod("session.turn.interrupt", { turnId })
        return result.interrupted
    }

    async abortTask(taskId: string): Promise<void> {
        await this.interruptTask(taskId).catch((err) => {
            console.error("[QueryManager] Failed to interrupt server-owned task:", err)
        })
    }

    private runningTurnId(taskId: string): string | null {
        return this.store.runtimes.activeTurnIdForTask(taskId)
    }
}
